
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const tokenId = JSON.parse(localStorage.getItem("tokenId"));
  return tokenId ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
